/**
 * Created by Ivan on 11.06.2026
 */

cleverapps.override(cleverapps.EVENTS, {
    SEASON_PASS: {
        DAU: "seasonpass_dau_",
        STAGE: "seasonpass_stage_",
        POINTS: "seasonpass_points_",
        WINDOW: "seasonpass_window_",
        RWCOST: "seasonpass_rwcost_",
        PURCHASE_WINDOW: "seasonpass_purchase_window",
        UPGRADE_WINDOW: "seasonpass_upgrade_window",
        LAST_CHANCE_WINDOW: "seasonpass_last_chance_window",
        BUY_VIP: "seasonpass_buy_vip",
        BUY_SUPER: "seasonpass_buy_super",
        BUY_UPGRADE: "seasonpass_buy_upgrade",
        BUY_LAST_CHANCE: "seasonpass_buy_last_chance",
        QUEST: "seasonpass_quest-",
        QUEST_BONUS: "seasonpass_quest_bonus",
        CHEST: "seasonpass_chest"
    }
});
